export default "__VITE_ASSET__Dl_6s0zZ__"